import { GET_HURRICANE_OUTLOOK_BULLETIN } from "../../../../actions/Hurricane/Outlook/Bulletin/hurricaneOutlookBulletinAction";
import {
	HurricaneOutlookBulletinPayload
} from "../../../../types/APIResponses/Hurricane/Outlook/hurricaneOutlookBulletinResponses";

export interface HurricaneOutlookBulletinReducerState {
	data?: HurricaneOutlookBulletinPayload;
	isFetching: boolean;
	requestError?: boolean | Record<string, unknown> | unknown;
}

const initialState: HurricaneOutlookBulletinReducerState = {
	data: undefined,
	isFetching: false,
	requestError: undefined
};

export function hurricaneOutlookBulletin(state = initialState, action) {
	switch (action.type) {
		case GET_HURRICANE_OUTLOOK_BULLETIN.pending:
		{
			return {
				...state,
				requestError: undefined,
				isFetching: true
			};
		}

		case GET_HURRICANE_OUTLOOK_BULLETIN.fulfilled:
		{
			return {
				...state,
				data: action.payload,
				isFetching: false,
				requestError: undefined
			};
		}

		case GET_HURRICANE_OUTLOOK_BULLETIN.rejected:
		{
			return {
				...state,
				data: undefined,
				isFetching: false,
				requestError: action.payload
			};
		}
		default:
		{
			return state;
		}
	}
}

